import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { IGKBruddtestResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import { Paper, Stack, Title } from "@mantine/core";
const Bruddtest: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKBruddtestResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Bruddtest</Title>
        <div className="d-flex flex-column mt-2">
          <b>Måletiden er 60 sekunder &#40;s&#41;:</b>
        </div>
        <div className="d-flex flex-column mt-2">
          <McInputNew
            label="Fyll inn målt hastighet i venstre hanskeport (m/s):"
            value={data.inndata.maaleresultatVenstre}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.bruddtest.inndata.maaleresultatVenstre", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-4">
          <McInputNew
            label="Fyll inn målt hastighet i høyre hanskeport (m/s):"
            value={data.inndata.maaleresultatHoeyre}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.bruddtest.inndata.maaleresultatHoeyre", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="w-50 mt-4">
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) => onUpdateEditData("testResultater.bruddtest.inndata.kommentar", e.target.value)}
          />
        </div>
      </Stack>
    </Paper>
  );
};
export default Bruddtest;